import { IProfileService } from "@/services/Profile/IProfileService";
import { ProfileService } from "@/services/Profile/ProfileService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";

export function bindProfileService(container:Container) {
    container.bind<IProfileService>(IoCTypes.ProfileService).to(ProfileService)
}